import { UrlBuilder } from '@common/utils/urlBuilder';

export function addEntityParameter(
    urlBuilder: UrlBuilder,
    params: { serviceGroupSettingId?: string; serviceOrganizationSettingId?: string }
) {
    if (params.serviceOrganizationSettingId) {
        urlBuilder.add('serviceOrganizationSettingId', params.serviceOrganizationSettingId);
    } else if (params.serviceGroupSettingId) {
        urlBuilder.add('serviceGroupSettingId', params.serviceGroupSettingId);
    }
}

export function getUrlWithParams(
    baseUrl: string,
    params: {
        groupId?: string;
        organizationId?: string;
        serviceGroupSettingId?: string;
        serviceId?: string;
        serviceOrganizationSettingId?: string;
    }
) {
    const urlBuilder = new UrlBuilder(baseUrl);
    addEntityParameter(urlBuilder, params);
    if (params.serviceId) {
        urlBuilder.add('serviceId', params.serviceId);
    }

    if (params.groupId) {
        urlBuilder.add('groupId', params.groupId);
    }

    if (params.organizationId) {
        urlBuilder.add('organizationId', params.organizationId);
    }

    return urlBuilder.build();
}
